import cartDataNotLoggedHtml from './cartdatanotlogged.component.html';
import './cartdatanotlogged.component.scss';

class CartDataNotLoggedController {
    constructor($scope, CartService, $sce) {
        'ngInject';
        this.$scope = $scope;
        this.service = CartService;
        this.$sce = $sce;
        this.countries = window.countries || ['Polska'];
    }

    $onInit() {
        this.service.step = 2;
        this.$scope.$watch(
            () => {
                if (!this.service.loaded || !this.service.summary) return null;

                return this.service.summary.country;
            },
            (newVal, oldVal) => {
                this.service.data.shipmentAddress.country = newVal;
            }
        );
    }

    updateInvoiceSelection(type) {
        if (type === 'invoice' && this.service.data[type]) {
            this.service.data.invoice_natural_person = false;
        }

        if (type === 'invoice_natural_person' && this.service.data[type]) {
            this.service.data.invoice = false;
        }
    }
}

let cartDataNotLoggedComponent = {
    bindings: {},
    template: cartDataNotLoggedHtml,
    controller: CartDataNotLoggedController
}

export default cartDataNotLoggedComponent;